import { connect } from 'react-redux';
import _ from 'lodash';

const OnlyInstructors = (props) => (props.is_instructor && props.children) || null;
export default connect(state => ({ is_instructor: _.get(state.user, 'is_instructor') }))(OnlyInstructors);
